import React from 'react';

const PhoneIcon: React.FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2951_72681)">
        <path
          d="M17.5 23.3L21.5 19.5C21.7 19.3 21.7 18.7 21.5 18.5L18.5 15.5C18.3 15.3 17.7 15.3 17.5 15.5L16 16.8C16 16.8 15.3 17.9 11.1 13.7L10.6 13.2C6.30001 8.89997 7.50001 8.49998 7.50001 8.49998L8.50001 7.49998C8.70001 7.29998 8.70001 6.69998 8.50001 6.49998L5.50001 3.49998C5.30001 3.29998 4.70001 3.29998 4.50001 3.49998L0.700012 7.49998C0.700012 7.49998 6.50001 17.1 17.5 23.3Z"
          stroke="#333333"
        />
      </g>
      <defs>
        <clipPath id="clip0_2951_72681">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PhoneIcon;
